'use strict';

module.exports = function countBy() {
  var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (value) {
    return value;
  };
  return new this.constructor(this.items).groupBy(fn).map(function (value) {
    return value.count();
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/countBy.js
// module id = 1641
// module chunks = 2